"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAbstract = void 0;
var request_1 = __importDefault(require("../request"));
var helper_1 = require("../../../core/helper");
var RequestAbstract = /** @class */ (function () {
    function RequestAbstract() {
    }
    RequestAbstract.prototype.load = function (params) {
        return request_1.default.load(params);
    };
    RequestAbstract.prototype.setBaseUrl = function (url) {
        (0, helper_1.setBaseUrl)(url);
    };
    return RequestAbstract;
}());
exports.RequestAbstract = RequestAbstract;
